import { render, staticRenderFns } from "./EditCategoryPrivilege.modal.vue?vue&type=template&id=1de5960e&scoped=true&"
import script from "./EditCategoryPrivilege.modal.vue?vue&type=script&lang=js&"
export * from "./EditCategoryPrivilege.modal.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryPrivilege.modal.vue?vue&type=style&index=0&id=1de5960e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5960e",
  null
  
)

export default component.exports